import { useFederatedComponent } from 'modules/app-registry/hooks/useFederatedComponent'
import { WidgetComponent } from 'modules/desktop/modules/widgets/types/widgets.types'

import { WidgetWrapper } from '../../../WidgetWrapper'

export const CalendarSmallWidget: WidgetComponent = ({ ...widgetProps }) => {
  const { module, isLoaded, isError, missingRemoteUrl } = useFederatedComponent(
    process.env.REACT_APP_CALENDAR_APP_DEV_PATH,
    'calendar',
    './CalendarSmallWidget',
    'calendarApp'
  )

  // @ts-expect-error: dynamic import
  const { CalendarSmallWidgetExposed: CalendarSmallWidget } =
    isLoaded && !isError && !missingRemoteUrl && module
      ? module
      : {
          CalendarSmallWidgetExposed: () => <></>
        }
  return (
    <WidgetWrapper {...widgetProps} isLoading={!isLoaded}>
      <CalendarSmallWidget />
    </WidgetWrapper>
  )
}
